<script>
import Navbar from '@components/navigation/navbar/navbar.vue'
import Footer from '@components/navigation/footer/footer.vue'
import { mapGetters } from 'vuex'

export default {
  components: { Navbar, Footer },
  computed: {
    ...mapGetters('translations', [
      'isLoading',
    ]),
  },
}
</script>

<template  >
  <div >
    <!-- <div v-if="isLoading"></div> -->
    <div v-if="!isLoading" class="main-container">
      <Navbar v-if="this.$route.query.mode !== 'iframe'"/>
        <slot />
      <Footer v-if="this.$route.query.mode !== 'iframe'" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
